import { cva } from 'class-variance-authority'

export const styles = cva('', {
  variants: {
    color: {
      'default-text': 'text-neutral-600',
      'disabled-text': 'text-neutral-400',
      'emphasis-text': 'text-moss-0',
      'header-text': 'text-neutral-900',
      'link-text': 'text-neutral-900',
      'muted-text': 'text-neutral-500',
      danger: 'text-danger',
      brand: 'brand',
      priority: 'priority',
    },
    textAlign: {
      center: 'text-center',
      left: 'text-left',
      right: 'text-right',
      inherit: 'text-inherit',
    },
    variant: {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'eyebrow',
    },
  },
  defaultVariants: {
    color: 'default-text',
    textAlign: 'left',
    variant: 'h1',
  },
})
